import isPropValid from '@emotion/is-prop-valid'
import { LazyMotion, MotionConfig } from 'motion/react'
import type { ReactNode } from 'react'

/**
 * O Motion 13 deixou de trazer o `@emotion/is-prop-valid` embutido; sem
 * informá-lo, props de animação vazam para o DOM quando componentes MUI
 * (Emotion) são animados.
 *
 * `domMax` entra por import dinâmico para ficar fora do bundle inicial da rota
 * `/login` (orçamento da §7.8), e `reducedMotion="user"` faz todo o Motion
 * respeitar a preferência do sistema.
 */
const loadFeatures = () => import('motion/react').then((module) => module.domMax)

export function MotionProvider({ children }: { children: ReactNode }) {
  return (
    <MotionConfig reducedMotion="user" isValidProp={isPropValid}>
      <LazyMotion features={loadFeatures} strict>
        {children}
      </LazyMotion>
    </MotionConfig>
  )
}
